"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorByKey = exports.getColorByName = exports.getColorById = exports.defaultColor = exports.colors = exports.taupe = exports.gray = exports.charcoal = exports.salmon = exports.magenta = exports.lavender = exports.violet = exports.grape = exports.blue = exports.lightBlue = exports.skyBlue = exports.turquoise = exports.mintGreen = exports.green = exports.limeGreen = exports.oliveGreen = exports.yellow = exports.orange = exports.red = exports.berryRed = void 0;
exports.berryRed = {
    id: 30,
    key: 'berry_red',
    displayName: 'Berry Red',
    name: 'Berry Red',
    hexValue: '#b8255f',
    value: '#b8255f',
};
exports.red = {
    id: 31,
    key: 'red',
    displayName: 'Red',
    name: 'Red',
    hexValue: '#db4035',
    value: '#db4035',
};
exports.orange = {
    id: 32,
    key: 'orange',
    displayName: 'Orange',
    name: 'Orange',
    hexValue: '#ff9933',
    value: '#ff9933',
};
exports.yellow = {
    id: 33,
    key: 'yellow',
    displayName: 'Yellow',
    name: 'Yellow',
    hexValue: '#fad000',
    value: '#fad000',
};
exports.oliveGreen = {
    id: 34,
    key: 'olive_green',
    displayName: 'Olive Green',
    name: 'Olive Green',
    hexValue: '#afb83b',
    value: '#afb83b',
};
exports.limeGreen = {
    id: 35,
    key: 'lime_green',
    displayName: 'Lime Green',
    name: 'Lime Green',
    hexValue: '#7ecc49',
    value: '#7ecc49',
};
exports.green = {
    id: 36,
    key: 'green',
    displayName: 'Green',
    name: 'Green',
    hexValue: '#299438',
    value: '#299438',
};
exports.mintGreen = {
    id: 37,
    key: 'mint_green',
    displayName: 'Mint Green',
    name: 'Mint Green',
    hexValue: '#6accbc',
    value: '#6accbc',
};
exports.turquoise = {
    id: 38,
    key: 'turquoise',
    displayName: 'Turquoise',
    name: 'Turquoise',
    hexValue: '#158fad',
    value: '#158fad',
};
exports.skyBlue = {
    id: 39,
    key: 'sky_blue',
    displayName: 'Sky Blue',
    name: 'Sky Blue',
    hexValue: '#14aaf5',
    value: '#14aaf5',
};
exports.lightBlue = {
    id: 40,
    key: 'light_blue',
    displayName: 'Light Blue',
    name: 'Light Blue',
    hexValue: '#96c3eb',
    value: '#96c3eb',
};
exports.blue = {
    id: 41,
    key: 'blue',
    displayName: 'Blue',
    name: 'Blue',
    hexValue: '#4073ff',
    value: '#4073ff',
};
exports.grape = {
    id: 42,
    key: 'grape',
    displayName: 'Grape',
    name: 'Grape',
    hexValue: '#884dff',
    value: '#884dff',
};
exports.violet = {
    id: 43,
    key: 'violet',
    displayName: 'Violet',
    name: 'Violet',
    hexValue: '#af38eb',
    value: '#af38eb',
};
exports.lavender = {
    id: 44,
    key: 'lavender',
    displayName: 'Lavender',
    name: 'Lavender',
    hexValue: '#eb96eb',
    value: '#eb96eb',
};
exports.magenta = {
    id: 45,
    key: 'magenta',
    displayName: 'Magenta',
    name: 'Magenta',
    hexValue: '#e05194',
    value: '#e05194',
};
exports.salmon = {
    id: 46,
    key: 'salmon',
    displayName: 'Salmon',
    name: 'Salmon',
    hexValue: '#ff8d85',
    value: '#ff8d85',
};
exports.charcoal = {
    id: 47,
    key: 'charcoal',
    displayName: 'Charcoal',
    name: 'Charcoal',
    hexValue: '#808080',
    value: '#808080',
};
exports.gray = {
    id: 48,
    key: 'gray',
    displayName: 'Gray',
    name: 'Gray',
    hexValue: '#b8b8b8',
    value: '#b8b8b8',
};
exports.taupe = {
    id: 49,
    key: 'taupe',
    displayName: 'Taupe',
    name: 'Taupe',
    hexValue: '#ccac93',
    value: '#ccac93',
};
exports.colors = [
    exports.berryRed,
    exports.red,
    exports.orange,
    exports.yellow,
    exports.oliveGreen,
    exports.limeGreen,
    exports.green,
    exports.mintGreen,
    exports.turquoise,
    exports.skyBlue,
    exports.lightBlue,
    exports.blue,
    exports.grape,
    exports.violet,
    exports.lavender,
    exports.magenta,
    exports.salmon,
    exports.charcoal,
    exports.gray,
    exports.taupe,
];
exports.defaultColor = exports.charcoal;
/**
 * @deprecated Use {@link getColorByKey} instead
 */
function getColorById(colorId) {
    var color = exports.colors.find(function (color) { return color.id === colorId; });
    return color !== null && color !== void 0 ? color : exports.defaultColor;
}
exports.getColorById = getColorById;
/**
 * @deprecated Use {@link getColorByKey} instead
 */
function getColorByName(colorName) {
    var color = exports.colors.find(function (color) { return color.name === colorName; });
    return color !== null && color !== void 0 ? color : exports.defaultColor;
}
exports.getColorByName = getColorByName;
function getColorByKey(colorKey) {
    var color = exports.colors.find(function (color) { return color.key === colorKey; });
    return color !== null && color !== void 0 ? color : exports.defaultColor;
}
exports.getColorByKey = getColorByKey;
